export default class Url
  # Replaces location search with provided params, then pushes state to history
  pushParamsToUrl: (options) ->
    if typeof options == "object"
      url = @locationOrigin() + window.location.pathname + '?' + @mapToQueryString(options.params)
    else if typeof options == "string"
      url = @locationOrigin() + window.location.pathname + '?' + options
    window.history.pushState(url, "", url)

  # Updates existing location search with provided params, then pushes state to history
  updateParamsInUrl: (params, updateMethod = "replace") ->
    search = window.location.search
    for key, value of params
      search = this.replaceValueInQueryString(search, key, value)

    url = this.locationOrigin() + window.location.pathname + search

    window.history.pushState(url, "", url) if updateMethod == "push"
    window.history.replaceState(url, "", url) if updateMethod == "replace"

  mapToQueryString: (map) ->
    return "" if Object.keys(map).length == 0
    (("#{k}=#{escape(v)}&" for k,v of map).reduceRight (x, y) -> x + y).slice(0, -1)

  replaceValueInQueryString: (queryString, key, value) ->
    queryMap = @queryToMap(queryString)
    queryMap[key] = value
    '?' + @mapToQueryString(queryMap)

  locationOrigin: ->
    if window.location.origin
      window.location.origin
    else
      window.location.protocol + "//" + window.location.hostname

  queryToMap: (queryString) ->
    queryMap = {}
    queryMap[pair.split('=')[0]] = unescape(pair.split('=')[1]) for pair in queryString.substring(1).split('&')
    return queryMap



// WEBPACK FOOTER //
// ./app/javascript/utils/shared/url.js.coffee